var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_4297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 9.99967C2.71209 9.99967 2.40146 9.99967 2.15643 9.89818C1.82973 9.76286 1.57016 9.50329 1.43484 9.17659C1.33334 8.93156 1.33334 8.62093 1.33334 7.99967V3.46634C1.33334 2.7196 1.33334 2.34624 1.47867 2.06102C1.6065 1.81014 1.81047 1.60616 2.06136 1.47833C2.34657 1.33301 2.71994 1.33301 3.46668 1.33301H8.00001C8.62127 1.33301 8.93189 1.33301 9.17692 1.4345C9.50363 1.56983 9.76319 1.82939 9.89852 2.1561C10 2.40112 10 2.71175 10 3.33301M8.13334 14.6663H12.5333C13.2801 14.6663 13.6534 14.6663 13.9387 14.521C14.1895 14.3932 14.3935 14.1892 14.5214 13.9383C14.6667 13.6531 14.6667 13.2797 14.6667 12.533V8.13301C14.6667 7.38627 14.6667 7.0129 14.5214 6.72769C14.3935 6.4768 14.1895 6.27283 13.9387 6.145C13.6534 5.99967 13.2801 5.99967 12.5333 5.99967H8.13334C7.38661 5.99967 7.01324 5.99967 6.72802 6.145C6.47714 6.27283 6.27317 6.4768 6.14534 6.72769C6.00001 7.0129 6.00001 7.38627 6.00001 8.13301V12.533C6.00001 13.2797 6.00001 13.6531 6.14534 13.9383C6.27317 14.1892 6.47714 14.3932 6.72802 14.521C7.01324 14.6663 7.38661 14.6663 8.13334 14.6663Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_4297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7a182e306632255e6fcfbfa51a177e43.svg";
export { ForwardRef as ReactComponent };